import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { apiFetch } from '../utils/api.js'
import './Login.css'

export default function Login() {
  const navigate = useNavigate()
  const location = useLocation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    const check = async () => {
      try {
        console.log('[LOGIN useEffect] Verificando se já está autenticado...')
        const res = await apiFetch('/api/auth/me')
        console.log('[LOGIN useEffect] Resposta /api/auth/me:', res.status)
        
        if (res.ok && active) {
          const data = await res.json()
          console.log('[LOGIN useEffect] Já autenticado:', data)
          const target = location.state?.from || '/empresas'
          console.log('[LOGIN useEffect] Redirecionando para:', target)
          navigate(target, { replace: true })
        } else {
          console.log('[LOGIN useEffect] Não autenticado, permanecendo na tela de login')
        }
      } catch (err) {
        console.error('[LOGIN useEffect] Erro ao verificar autenticação:', err)
        // ignore
      }
    }
    check()
    return () => {
      active = false
    }
  }, [location.state, navigate])

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setLoading(true)
    
    console.log('[LOGIN] Iniciando processo de login...')
    console.log('[LOGIN] Username:', username)
    
    try {
      console.log('[LOGIN] Chamando API /api/auth/login')
      const res = await apiFetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })
      
      console.log('[LOGIN] Resposta recebida:', res.status, res.statusText)
      
      if (!res.ok) {
        const body = await res.json().catch(() => ({}))
        console.error('[LOGIN] Erro na autenticação:', body)
        throw new Error(body.message || 'Falha ao autenticar')
      }
      
      const responseData = await res.json()
      console.log('[LOGIN] Login bem-sucedido:', responseData)

      if (responseData?.token) {
        localStorage.setItem('ondax:token', responseData.token)
      }
      
      const storedTarget = sessionStorage.getItem('ondax:returnTo')
      if (storedTarget) sessionStorage.removeItem('ondax:returnTo')
      const target = location.state?.from || storedTarget || '/empresas'
      console.log('[LOGIN] Navegando para:', target)
      
      navigate(target, { replace: true })
      
      console.log('[LOGIN] Navigate chamado com sucesso')
    } catch (err) {
      console.error('[LOGIN] Erro:', err)
      setError(err.message || 'Falha ao autenticar')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Onda X</h1>
        <p>Faça login para acessar o painel.</p>
        {error ? <div className="login-error">{error}</div> : null}
        <label>
          Usuário
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Seu usuário"
            required
          />
        </label>
        <label>
          Senha
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Sua senha"
            required
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  )
}
